import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const CustomPhoneInput = ({
  value,
  onChange,
  label,
  isRequired = false,
  disabled = false,
}) => {
  const handlePhoneChange = (phone, country) => {
    let formattedValue = phone;

    // Si empieza con "0", eliminamos cualquier prefijo de país.
    if (phone.startsWith("0")) {
      formattedValue = phone.replace(/^\+/, "");
    }

    onChange(formattedValue);
  };

  return (
    <div className="poppins-medium flex flex-col space-y-1 tracking-wider">
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">
          {label}
          {isRequired && <span className="text-[#BF1F2E]">*</span>}
        </label>
      )}
      <div className="relative">
        <PhoneInput
          country={"py"} // País por defecto (Paraguay)
          value={value}
          onChange={handlePhoneChange}
          disabled={disabled}
          disableCountryCode={value?.startsWith("0")}
          inputStyle={{
            width: "100%",
            height: "48px",
            borderRadius: "9px",
            backgroundColor: "#F9FAFB",
            fontSize: "10px",
            padding: "16px 12px 16px 50px",
            border: "1px solid #ccc",
          }}
          buttonStyle={{
            borderRadius: "9px",
            backgroundColor: "#F9FAFB",
            borderRight: "1px solid #ccc",
            width: "45px",
            height: "48px",
          }}
          dropdownStyle={{ borderRadius: "9px" }}
        />
      </div>
    </div>
  );
};

export default CustomPhoneInput;
